import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { Popup, Image } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ItemDetailImage extends Component {

    componentWillMount() {
        this._image = <FontAwesomeIcon icon={this.icon} size="lg" fixedWidth={true}/>;
        this._imageDisabled = <Image rounded size='mini' src={this.icon} className="item-cell disabled" />;

        if(this.property) {
            this._trigger = this.createTrigger(this.property.length > 1 ? this.multipleItemUrl : this.singleItemUrl);
            this._content = (this.property.length > 1) ? this.multipleItemContent : this.singleItemContent;
        }
    }

    get property() {
        return this._property;
    }

    set property(value) {
        this._property = value;
    }

    get icon() { }

    get singleItemUrl() {
        return this._singleItemUrl;
    }

    set singleItemUrl(value) {
        this._singleItemUrl = value;
    }

    get multipleItemUrl() {
        return this._multipleItemUrl;
    }

    set multipleItemUrl(value) {
        this._multipleItemUrl = value;
    }

    get singleItemContent() {
        return this._singleItemContent;
    }

    set singleItemContent(value) {
        this._singleItemContent = value;
    }

    get multipleItemContent() {
        return this._multipleItemContent;
    }

    set multipleItemContent(value) {
        this._multipleItemContent = value;
    }

    get header() {
        return this._header;
     }

     set header(value) {
         this._header = value;
     }

    render() {
        if(!this.property) {
            return this._imageDisabled;
        } else if(this.property.length > 1) {
            return <Popup trigger={this._trigger} content={this._content} />
        } else {
            return <Popup trigger={this._trigger} content={this._content} header={this.header} />
        }
    }

    createTrigger(url) {
        return (
            <Link to={url}>
                {this._image}
            </Link>
        )
    }
}



// WEBPACK FOOTER //
// ./src/items/index/ItemDetailImage.jsx